import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_PHONE_CREATION_REQUEST } from '@/api/endpoints';
import type { PersonType } from '@/types/user';

interface CreatePhoneRequest {
  personType: PersonType;
  targetUserPublicId: string;
  phoneNumber: string;
  message: string;
}

export const useCreatePhone = () => {
  const { mutateAsync: createPhone, isPending } = useMutation({
    mutationFn: (request: CreatePhoneRequest) =>
      apiClient.post(API_PHONE_CREATION_REQUEST, request),
  });

  return { createPhone, isPending };
};
